import { FLIGHT_INCLUSIONS } from "src/Modules/Flights/constants/JourneyDetails";
import { explode, getValue } from "src/utility";
import { useJourneyStaticDetails } from "../../../../context";
import { useSSRContext } from "../../context/SSRContext";
import { generateBaggageOptions, getBaggageLabel } from "../../utils";
import ItemSelection from "../ItemSelection/ItemSelection";
import PassengerDeclaration from "../PassengerDecleration";

export default function BaggageSelection() {
  const { cursor, flightOptions } = useSSRContext();
  const { journeyDetails, journeySearchData } = useJourneyStaticDetails();
  const { data } = explode(journeyDetails, {});
  const flightSelected = flightOptions.find((option) => option.value === cursor.flightId);
  const baggageOptions = generateBaggageOptions(flightSelected, data?.ssr?.baggage);
  const flight = journeySearchData.segments?.[0]?.flights?.[0];
  const inclusions = FLIGHT_INCLUSIONS.filter((inclusion) => ["carryOn", "checkedBaggage"].includes(inclusion.key));

  const items = baggageOptions?.map((baggage) => ({
    option: baggage,
    label: baggage.text ?? getBaggageLabel(baggage),
    price: baggage.price,
    currency: baggage.currency,
  }));

  return (
    <div className="flex flex-col gap-4">
      <PassengerDeclaration
        extraInfo={inclusions.map((inclusion) => {
          const value = getValue(flight, inclusion.path);
          const displayValue = inclusion.transform ? inclusion.transform(value) : value;
          if (!displayValue) return null;
          return (
            <div key={inclusion.key} className="text-font-success bg-background-success flex items-center gap-1 rounded-full px-3 py-1 text-xs *:text-xs!">
              <span className="aspect-square w-4">{inclusion.icon}</span>
              {displayValue}
            </div>
          );
        })}
      />
      <ItemSelection ssrType="baggages" trackLabel="Baggage" items={items} className="bg-background-default grid-cols-1 rounded-md md:grid-cols-2" />
    </div>
  );
}
